import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from './store';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import LandingPage from './pages/LandingPage'; // Import the new Landing Page
import Login from './pages/Login';
import Register from './pages/Register';
import Pricing from './pages/Pricing';
import AcceptInvite from './components/setting/Acceptinvite';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Attendance from './pages/Attendance';
import Payroll from './pages/Payroll';
import Payslips from './pages/Payslips';
import Reports from './pages/Reports';
import Compliance from './pages/Compliance';
import Settings from './pages/Settings';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            {/* Changed from Navigate to the actual LandingPage component */}
            <Route path="/"               element={<LandingPage />} /> 
            <Route path="/login"          element={<Login />} />
            <Route path="/register"       element={<Register />} />
            <Route path="/pricing"        element={<Pricing />} />
            <Route path="/accept-invite"  element={<AcceptInvite />} />

            {/* Protected — requires auth */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/dashboard"  element={<Dashboard />} />
                <Route path="/employees"  element={<Employees />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/payroll"    element={<Payroll />} />
                <Route path="/payslips"   element={<Payslips />} />
                <Route path="/reports"    element={<Reports />} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/settings"   element={<Settings />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;